import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import enhanceWithClickOutside from 'react-click-outside'

import Icon from '../Icon'

class Tooltip extends Component {
  state = {
    isActive: false,
  }

  onClick = () => {
    this.setState({
      isActive: !this.state.isActive,
    })
  }

  handleClickOutside = () => {
    this.setState({
      isActive: false,
    })
  }

  render() {
    const { classes, errorMessage, inlineError } = this.props

    return (
      <div
        className={classNames(classes.container, {
          [classes.inlineError]: inlineError,
        })}
        onClick={this.onClick}
      >
        <Icon name="warning" className={classes.icon} />
        <span
          data-element="tooltip"
          className={classNames(classes.tooltip, {
            [classes.isActive]: this.state.isActive,
          })}
        >
          {errorMessage}
        </span>
      </div>
    )
  }
}

Tooltip.propTypes = {
  errorMessage: PropTypes.string,
  inlineError: PropTypes.bool,
  classes: PropTypes.shape({
    container: PropTypes.string,
    tooltip: PropTypes.string,
    isActive: PropTypes.string,
    inlineError: PropTypes.string,
    icon: PropTypes.string,
  }),
}

export default enhanceWithClickOutside(Tooltip)
